/**
 * nin: logErrorTracker decorator
 * 
 */
import React, {Component} from "react";
import ErrorReportingTool from '../config/ErrorReportingTool';
import ErrorBoundary from '../boundary'
import { EVENT } from '../events/listEvents';


export default function logErrorTracker() {
   	let dataError = {};

    return function(Child) {
      return class extends Component {
         render() {
           return (             
             <ErrorBoundary>
                <Child {...this.props}/>
              </ErrorBoundary>
           )
        }

        componentWillMount() {
            this.startErrorLog();
        }

        componentDidMount() {
            window.listenEvent(EVENT.ErrorsHappenOnPage, this.reportLog)
        }

        componentWillUnmount() {
              window.stopListenEvent(EVENT.ErrorsHappenOnPage, this.reportLog)
        }
        
        reportLog = () => {
            ErrorReportingTool.reportData(dataError);
        }

  /**
   * Log error
   * 
   */
  startErrorLog = () => {
    window.onerror = (message, file, line, column, errorObject) => {
      try {

        column = column || (window.event && window.event.errorCharacter);
        let stack = errorObject ? errorObject.stack : null;
        //alert('Catch error')

        //trying to get stack from IE
        if (!stack) {
          let stack = [];
          let f = arguments.callee.caller;
          while (f) {
            stack.push(f.name);
            f = f.caller;
          }
          errorObject['stack'] = stack;
        }

        let data = {
          message: message,
          file: file,
          line: line,
          column: column,
          errorStack: stack,
        };
        //// console.log('error_data', data);
        if (stack != null && !stack.includes('LifeCycles') && !stack.includes('ErrorBoundary')) {
          // console.log("stack", stack);
          dataError = data;
          window.fireEvent(EVENT.ErrorsHappenOnPage)
          return false;
        }
      } catch (error) {

      }
      return true;
    }
  }

  }
  }
}




// WEBPACK FOOTER //
// ./src/app/common/decorator/logErrorTracker.js